<template>
  <AmountInput
    v-bind="context.attrs"
    :id="context.id"
    v-model="value"
    :name="context.node.name"
    :class="context.classes.input"
    :disabled="context.disabled"
    @blur="context.handlers.blur"
  />
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue';
import type { FormKitFrameworkContext } from '@formkit/core';
import AmountInput from '@/components/elements/AmountInput.vue';

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext & {}>,
    required: true,
  },
});

const value = computed({
  get() {
    return Number(props.context._value) || 0;
  },
  set(newValue) {
    props.context.node.input(newValue);
  },
});
</script>
